import { Helmet } from 'react-helmet-async';
import { useParams, useSearchParams } from 'react-router-dom';
import { useScopeCheck } from '../../../../reusable-components/scopes';
import { CartsProvider } from '../../../../components/dashboard/orders/new-order/cart/_CartsContext';
import CartList from '../../../../components/dashboard/orders/new-order/cart/CartList';

export default function NewCart() {
  const canViewCart = useScopeCheck(["View-Order"], true);
  const canCartCheck = useScopeCheck(['Cart-Check', 'Edit-Order'], true);
  const { facilityId = '' } = useParams();
  const [urlParams, setUrlParams] = useSearchParams();
  const categoryId = urlParams.get('categoryId');
  const punchoutFailed = urlParams.get('punchoutFailed');

  return <>
    <Helmet>
      <title>Cart | Platform Solutions</title>
    </Helmet>

    <CartsProvider facilityId={facilityId} categoryId={categoryId ? Number(categoryId) : null} setUrlParams={setUrlParams} >
      <CartList canCartCheck={canCartCheck} canViewCart={canViewCart} punchoutFailed={punchoutFailed === "true"} />
    </CartsProvider>
  </>;
}
